import { useCallback, useEffect, useState } from 'react'
import { api } from './api'

// Filter and route changes invalidate older responses. Refreshes keep the
// current page visible, so an action's confirmation is not unmounted.
export function useAdminResource<T>(path: string) {
  const [revision, setRevision] = useState(0)
  const [state, setState] = useState<{ path: string; data: T | null; busy: boolean; error: string }>({ path, data: null, busy: true, error: '' })
  useEffect(() => {
    const controller = new AbortController()
    setState(previous => ({ path, data: previous.path === path ? previous.data : null, busy: true, error: '' }))
    api<T>(path, { signal: controller.signal }).then(data => {
      if (!controller.signal.aborted) setState({ path, data, busy: false, error: '' })
    }).catch(error => {
      if (!controller.signal.aborted) setState({ path, data: null, busy: false, error: error instanceof Error ? error.message : 'Could not load this page.' })
    })
    return () => controller.abort()
  }, [path, revision])
  const reload = useCallback(() => setRevision(value => value + 1), [])
  return { data: state.path === path ? state.data : null, busy: state.path !== path || state.busy, error: state.path === path ? state.error : '', reload }
}
